<ng-container *ngIf="warranty">
  <vs-content-card
    [header]="{
      title: (warranty.policy?.friendlyTitle || warranty.policy?.title) + ' - ' + warranty.plan?.title,
      subtitle: warranty.policy?.tagline,
    }"
  >
    <div headerEnd class="flex items-center gap-2">
      <button *ngIf="renewalEligible" vs-button appearance="outline" size="sm" (click)="renewModal.open(warranty)">
        Renew Coverage
      </button>

      <ws-view-declaration-button
        *ngIf="canShowDeclaration$ | async"
        appearance="outline"
        size="sm"
        [icon]="'file-06'"
        [buttonClass]="'flex items-center gap-2'"
        [warrantyId]="warranty.id"
        [contractNumber]="warranty.contractNumber"
        [successTitle]="'Registration Generated'"
        [openedText]="'Your warranty registration has been opened in a new tab.'"
        [downloadedText]="'Your warranty registration has been downloaded.'"
        [showBlockedToast]="false"
      ></ws-view-declaration-button>

      <ws-warranty-status-drop-down
        [warrantyStatus]="warranty.status"
        [asset]="warranty.asset"
        [propertySetId]="warranty.policy?.propertySetId"
        [warrantyValidity]="warranty.policy?.validity"
        [transactionCloseDate]="warranty.transactionCloseDate || undefined"
        [warrantyTermDuration]="warranty.termDuration"
        [warrantyStartDate]="warranty.termStart"
        [expiryDate]="warranty.expiryDate || undefined"
      ></ws-warranty-status-drop-down>
    </div>

    <ng-container *ngIf="isNoLongerActive">
      <div class="p-5 pb-0">
        <div class="vs-card p-4 flex flex-col gap-3" color="error">
          <p class="text-gray-900 font-bold text-error-800 flex items-center gap-2">
            <vs-icon size="20" name="alert-circle"></vs-icon>
            This warranty is no longer active
          </p>
        </div>
      </div>
    </ng-container>

    <ws-coverage-carousel class="block" [warranty]="warranty" [isCustomerPortal]="true"></ws-coverage-carousel>
  </vs-content-card>

  <ws-renew-warranty-modal #renewModal (renewed)="renewed.emit($event)"></ws-renew-warranty-modal>
</ng-container>
